import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { verify } from '@/util/session'
import { applyRouteSeo, privateRobots } from '@/util/seo'

Vue.use(VueRouter)

// Public pages explain the service and may be indexed; the canonical URL is always the site root
// because hash fragments are not separate URLs for search engines (see util/seo.js).
const HOME_TITLE = "Let's SSL - Free SSL Certificate Automation Service"
const HOME_DESCRIPTION = "Let's SSL provides free SSL certificate automation using Let's Encrypt. Create an order, publish one DNS TXT record, verify — then download your certificate. No command line, no account juggling."

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: {
            title: HOME_TITLE,
            description: HOME_DESCRIPTION,
        },
        component: Home
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        meta:{
            title: 'Dashboard - Let\'s SSL',
            robots: privateRobots,
        },
        component: () => import(/* webpackChunkName: "about" */ '../components/Dashboard.vue')
    },
    {
        path: '/donate',
        name: 'Donate',
        meta: {
            title: 'Donate - Let\'s SSL',
            description: 'Support the hosting and development of Let\'s SSL, a free service that issues and renews Let\'s Encrypt certificates for you.',
            robots: privateRobots,
        },
        component: () => import(/* webpackChunkName: "about" */ '../components/Donate.vue')
    },
    {
        path: '/login',
        name: 'Login',
        meta: {
            title: 'Sign in or create an account - Let\'s SSL',
            description: 'Sign in to Let\'s SSL to create certificate orders, check DNS validation and download your certificates.',
            robots: privateRobots,
        },
        component: () => import(/* webpackChunkName: "about" */ '../components/Login.vue')
    },
    {
        path: '/resetPassword',
        name: 'ResetPassword',
        meta: {
            title: 'Reset your password - Let\'s SSL',
            robots: privateRobots,
        },
        component: () => import(/* webpackChunkName: "about" */ '../components/ResetPassword.vue')
    },
    {
        // mode: new = start a fresh order; resume = continue the order in localStorage.
        // Kept in the path (not only in route params): the context survives a page refresh,
        // whereas params (openWizard passing isNew=false) existed only in memory and the order was cleared on refresh
        path: '/addCert/:mode?',
        name: 'AddCert',
        meta: {
            title: 'Add a certificate - Let\'s SSL',
            robots: privateRobots,
        },
        component: () => import(/* webpackChunkName: "about" */ '../components/AddCert.vue')
    },
]

const router = new VueRouter({
    routes
})

// Console pages need a live session. localStorage alone goes stale (the cookie expires after 30 minutes
// of inactivity), so the guard verifies against the server before entering and remembers the target
// so the login can send the user back.
const AUTH_REQUIRED = ['Dashboard', 'AddCert']

router.beforeEach(async (to, from, next) => {
    applyRouteSeo(to)
    if (!AUTH_REQUIRED.includes(to.name)) return next()
    if (await verify({ askServer: true })) return next()
    next({ path: '/login', query: { redirect: to.fullPath } })
})

export default router
